<template>
  <v-dialog v-model="modal" scrollable>
    <v-card>
      <v-card-title>
        Sélection d'instance
      </v-card-title>
      <v-card-subtitle>{{ subtitle }}</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <search-by
              :datasource="datasource"
              attr="nom"
              i18n="recherche.rechercheSimple.instance.search.nom"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <search-by
              :datasource="datasource"
              attr="id"
              i18n="recherche.rechercheSimple.instance.search.id"
            />
          </v-col>
        </v-row>
        <datasource-table style="height:480px;" :datasource="datasource">
          <template #item.id="{item}">
            <a @click="select(item)">
              {{ item.id }}
            </a>
          </template>
          <template #item.nom="{item}">
            <a @click="select(item)">
              {{ item.nom }}
            </a>
          </template>
          <template #item.typeParticipant="{item}">
            <a @select="select(item)">
              <v-select
                v-model="item.type"
                dense
                :items="enums.typesParticipant"
                item-text="libelle"
              >
                {{ item.libelle }}
              </v-select>
            </a>
          </template>
        </datasource-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeModal" text>
          {{ $t('button.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Datasource from '@/utils/datasource';
import toasted from '@/utils/toasted';

export default {
  props: {
    subtitle: {
      type: String,
    },
  },
  data() {
    const datasource = new Datasource('recherche/simple/instance', {
      page: 1,
      rowsPerPage: 20,
      sortBy: ['nom'],
      descending: [false],
      labelNamespace: 'recherche.rechercheSimple.instance.list',
      args: {
        actif: true,
      },
      fields: [
        // ...this.fieldName,
        {
          value: 'id',
          sortable: false,
        },
        {
          value: 'nom',
          sortable: true,
        },
        {
          value: 'typeParticipant',
          sortable: false,
        },
      ],
    });
    return {
      datasource,
      modal: false,
      type: null,
      enums: {
        typesParticipant: [],
      },
    };
  },
  methods: {
    show() {
      this.modal = true;

      this.$api('enums/instance')
        .get()
        .then(response => {
          const body = response.body;
          const enums = this.enums;
          enums.typesParticipant = body.typesParticipant;
        });
    },
    select(item) {
      if (item.type) {
        this.modal = false;

        const valeur = {
          id: item.id,
          nom: item.nom,
          role: item.type,
          typeInstance: item.typeInstance,
        };

        this.$emit('input', valeur);
      } else {
        toasted.error('instance.ajouterParticipant.roleManquant');
      }
    },
    closeModal() {
      this.modal = false;
    },
  },
};
</script>
